import styles from "./Backdrop.module.css";

function Backdrop() {
  return <div className={styles.backdrop} />;
}

export default Backdrop;
